import axios from 'utils/axios';

export const getEmailTemplates = async () => {
    const response = await axios.get('email-templates');
    return response.data;
};

export const editEmailTemplate = async (data) => {
    const result = await axios.put('email-templates', data);
    return result.data;
};
